const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  transfer ({ state, commit, rootState }, params) {
    return rootState.axios.post('/splicegroup/v1frontend/splicegroup-parcel/transfer', params)
  },
  confirm ({ state, commit, rootState }, params) {
    return rootState.axios.post('/splicegroup/v1frontend/splicegroup-parcel/confirm', params)
  },
  // 給團長評分
  updatePublisherScore ({ state, commit, rootState }, params) {
    return rootState.axios.post('/splicegroup/v1frontend/splicegroup-parcel/update-publisher-score', params)
  },
  // 給團員評分
  updateJoinerScore ({ state, commit, rootState }, params) {
    return rootState.axios.post('/splicegroup/v1frontend/splicegroup-parcel/update-joiner-score', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
